import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SKIP_VISIBLE_VIOLATIONS = 'VISIBLE_VIOLATIONS :: SKIP';

export type TSkipVisibleViolationsAction = IReduxAction<typeof SKIP_VISIBLE_VIOLATIONS>;

export const skipVisibleViolations = actionGenerator<typeof SKIP_VISIBLE_VIOLATIONS>(SKIP_VISIBLE_VIOLATIONS);
